var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6e6e6e",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 576.3 576.301",
    xmlSpace: "preserve",
    stroke: "#6e6e6e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_144_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M264.563,494.699c7.65,1.275,15.3,1.275,24.225,1.275s17.85,0,26.775-1.275l3.825-124.949 c-7.65-3.824-15.3-8.926-21.675-15.301c-11.476-12.75-17.851-29.324-16.575-47.174l6.375-85.425 c-7.65,10.2-17.85,17.85-30.6,22.95L264.563,494.699z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.888,49.725v54.825c52.274,44.625,85.425,110.925,85.425,184.875c0,73.949-33.15,140.25-85.425,184.875v54.824 c77.774-51,128.774-138.975,128.774-239.699C575.663,188.7,524.663,100.725,446.888,49.725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.713,30.6v14.025c1.274,0,2.55,0,5.1,0c5.1-16.575,15.3-30.6,29.325-40.8C318.113,1.275,302.813,0,288.788,0 c-1.275,0-3.825,0-5.1,0C291.338,8.925,297.713,19.125,297.713,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.888,156.825v22.95V349.35v71.4c30.6-35.699,48.45-81.6,48.45-132.6C494.063,239.7,477.488,192.525,446.888,156.825z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.188,192.525c-15.3,29.325-24.225,61.2-24.225,95.625c0,54.824,21.675,104.549,56.1,141.525l6.375-187.426 C123.038,235.875,107.738,216.75,105.188,192.525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.013,535.5v-3.824c-8.925,1.273-16.575,1.273-25.5,1.273c-7.65,0-15.3,0-22.95-1.273v3.824 c0,14.025-5.1,28.051-14.025,38.25c11.475,1.275,24.225,2.551,35.7,2.551c12.75,0,25.5-1.275,38.25-2.551 C318.113,563.551,313.013,549.525,313.013,535.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.988,289.426c0-61.201,22.95-118.576,61.2-160.651v-61.2c-63.75,52.275-104.55,132.6-104.55,221.851 c0,102,53.55,192.523,133.875,243.523l1.275-52.273C80.963,436.051,43.988,365.926,43.988,289.426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.963,11.475L386.963,11.475c-33.15,0-61.2,25.5-63.75,58.65l-16.575,238.426c-1.275,10.199,2.55,20.398,10.2,28.049 c7.649,7.65,16.574,12.75,28.05,12.75h1.274l-6.375,187.426c0,7.65,2.551,15.299,8.926,21.674 c5.1,6.375,12.75,8.926,21.675,8.926h21.675c16.575,0,29.325-14.025,29.325-29.324V349.35V179.775V45.9 C421.388,26.775,406.088,11.475,386.963,11.475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.413,221.85h6.375c19.125,0,35.7-15.3,35.7-34.425V30.6c0-6.375-5.1-11.475-11.475-11.475h-2.55 c-6.375,0-10.2,5.1-10.2,11.475v103.275c0,8.925-7.65,16.575-16.575,16.575h-2.55c-8.925,0-16.575-7.65-16.575-16.575V30.6 c0-6.375-5.1-11.475-10.2-11.475h-2.55c-6.375,0-11.475,5.1-11.475,11.475v103.275c0,8.925-7.65,16.575-16.575,16.575h-2.55 c-8.925,0-16.575-7.65-16.575-16.575V30.6c0-6.375-5.1-11.475-10.2-11.475h-2.55c-6.375,0-10.2,5.1-10.2,11.475v156.825 c0,19.125,15.3,34.425,34.425,34.425h5.1l-10.2,314.925c0,7.65,2.55,15.299,7.65,21.674c5.1,5.102,12.75,8.926,20.4,8.926h22.95 c7.65,0,15.3-3.824,20.4-8.926c5.1-5.1,8.925-14.023,7.65-21.674L231.413,221.85z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestKitchen);
export default __webpack_public_path__ + "static/media/test-kitchen.0531b16d06cbd63f3d6431264aaed692.svg";
export { ForwardRef as ReactComponent };